<template>
    <span v-if="mostrarIcone">
        <span class="text-primary ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Detalhar"
                @click.stop="toDetalhar()"
            ></i>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        projeto: {
            type: Object,
            default: () => ({})
        },

        etapa: {
            type: Object,
            default: () => ({})
        },

        rotaDetalhar: {
            type: String
        },

        permiteAcesso: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {}
    },

    methods: {
        toDetalhar() {
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    etapaId: this.etapa.etapaId,
                    etapa: this.etapa,
                    projeto: this.projeto
                }
            })
        }
    },

    computed: {
        mostrarIcone() {
            return (
                this.permiteAcesso 
                // && this.etapa.temDespesas
            )
        }
    }
}
</script>
